import { LiveFeedStreamEntry } from '@spikemark/live';
import { QuotedTweet, TweetContainer, TweetHeader, TweetLink, TweetMedia, TweetSkeleton, enrichTweet, useTweet, type TwitterComponents } from 'react-tweet';
import { FeedEntryByline } from './feed-entry-shared';
type Props = {
  tweetId: string;
  components?: TwitterComponents;
  baseDate: Date;
  tournamentId?: number | null;
  tournamentName?: string | null;
  isAggregated?: boolean;
};
export const TweetFeedItem = ({
  tweetId,
  components,
  baseDate,
  tournamentId,
  tournamentName,
  isAggregated
}: Props) => {
  const t = useTweet(tweetId);
  const tweet = t.data ? enrichTweet(t.data) : null;
  return tweet ? <TweetContainer className="!max-w-none !m-0 *:!px-0 *:!pt-0 !font-nunito !bg-white !text-gray-900 !border-0 !rounded-none" data-sentry-element="TweetContainer" data-sentry-component="TweetFeedItem" data-sentry-source-file="tweet.tsx">
      <FeedEntryByline baseDate={baseDate} entryDate={new Date(tweet.created_at)} tournamentId={tournamentId} tournamentName={tournamentName} showTournament={isAggregated} data-sentry-element="FeedEntryByline" data-sentry-source-file="tweet.tsx" />
      <TweetHeader tweet={tweet} components={components} data-sentry-element="TweetHeader" data-sentry-source-file="tweet.tsx" />
      {/* {tweet.in_reply_to_status_id_str && <TweetInReplyTo tweet={tweet} />} */}
      <div className="text-base md:text-lg lg:text-xl">
        {tweet.entities.map((item, i) => {
        switch (item.type) {
          case 'hashtag':
          case 'mention':
          case 'url':
          case 'symbol':
            return <TweetLink href={item.href} key={i}>
                  {item.text}
                </TweetLink>;
          default:
            return <span key={i} dangerouslySetInnerHTML={{
              __html: item.text
            }} />;
        }
      })}
      </div>
      <div className="pb-1 lg:pb-0">
        {tweet.mediaDetails?.length ? <TweetMedia tweet={tweet} components={components} /> : null}
        {tweet.quoted_tweet && <QuotedTweet tweet={tweet.quoted_tweet} />}
        {/* <TweetInfo tweet={tweet} /> */}
        {/* <div className="hidden @md:block">
          <TweetActions tweet={tweet} />
         </div> */}
      </div>
    </TweetContainer> : <TweetSkeleton data-sentry-element="TweetSkeleton" data-sentry-component="TweetFeedItem" data-sentry-source-file="tweet.tsx" />;
};